import angular from 'angular'
import template from './template.html'

angular.module('nominas.cotizaciones')
  .component('nominasCotizacionesAgregar', {
    template: template,
    bindings: {
      onAgregar: '<',
      onCancelar: '&',
    },
    controller: Component,
  });

function Component(NominasCotizaciones) {
  let $ctrl = this,
    proyectos;

  // Flags
  $ctrl.agregando = false;
  // Variables
  $ctrl.data = {
    Fecha_Final: undefined,
    Fecha_Inicial: undefined,
    Fecha_Pago: undefined,
    ID_Modalidad: undefined,
    Notas: '',
    Proyecto: undefined,
  };
  $ctrl.proyectos = undefined;
  // Methods
  $ctrl.agregar = agregar;
  $ctrl.agregarProyecto = agregarProyecto;
  $ctrl.cancelar = cancelar;
  $ctrl.eliminarProyecto = eliminarProyecto;
  $ctrl.filtrarProyectos = filtrarProyectos;
  $ctrl.cambiarModalidad = cambiarModalidad;

  NominasCotizaciones
    .listaProyectos()
    .then(function (data) {
      // proyectos = data;
      $ctrl.proyectos = data;
      // $ctrl.filtrarProyectos();
    });

  function cambiarModalidad() {
    $ctrl.data.ID_Modalidad = $ctrl.data.Proyecto.Modalidad === 1 ? 'Asimilados Salarios' : 'Sueldos y Salarios';
  }

  function agregar() {
    $ctrl.agregando = true;
    return NominasCotizaciones
      .agregar($ctrl.data)
      .then($ctrl.onAgregar);
  }

  function agregarProyecto(item) {
    if ($ctrl.data.Proyectos.indexOf(item) < 0)
      $ctrl.data.Proyectos.push(item);
    $ctrl.filtrarProyectos();
  }

  function cancelar() {
    $ctrl.onCancelar();
  }

  function eliminarProyecto(item) {
    $ctrl.data.Proyectos.splice($ctrl.data.Proyectos.indexOf(item), 1);
  }

  function filtrarProyectos() {
    $ctrl.proyectos = proyectos.filter(function (item) {
      return item.Modalidad == $ctrl.data.ID_Modalidad
        && $ctrl.data.Proyectos.indexOf(item) < 0;
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cotizaciones/components/agregar/controller.js